/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetPayoutDetailsResponseBankAccount } from './getPayoutDetailsResponseBankAccount';
import { GetPayoutDetailsResponseOrganizer } from './getPayoutDetailsResponseOrganizer';
import { PayoutEventDto } from './payoutEventDto';


export interface GetPayoutDetailsResponse { 
    /**
     * Payout request ID
     */
    id: string;
    /**
     * Organizer user ID
     */
    organizerId: string;
    organizer: GetPayoutDetailsResponseOrganizer;
    /**
     * Total payout amount in cents
     */
    amount: number;
    /**
     * Current payout status
     */
    status: GetPayoutDetailsResponse.StatusEnum;
    /**
     * Request timestamp
     */
    requestedAt: string;
    /**
     * Approval timestamp
     */
    approvedAt?: string;
    /**
     * Admin ID who approved
     */
    approvedBy?: string;
    /**
     * Processing completion timestamp
     */
    processedAt?: string;
    /**
     * Payout completed (paid) timestamp
     */
    paidAt?: string;
    /**
     * Stripe payout ID
     */
    stripePayoutId?: string;
    /**
     * Failure/rejection reason
     */
    failureReason?: string;
    /**
     * Array of linked events with earnings
     */
    events: Array<PayoutEventDto>;
    /**
     * Additional payout metadata
     */
    metadata?: object;
    bankAccount?: GetPayoutDetailsResponseBankAccount | null;
    /**
     * Last updated timestamp
     */
    updatedAt?: string;
}
export namespace GetPayoutDetailsResponse {
    export type StatusEnum = 'pending' | 'approved' | 'in_transit' | 'paid' | 'declined' | 'failed' | 'canceled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Approved: 'approved' as StatusEnum,
        InTransit: 'in_transit' as StatusEnum,
        Paid: 'paid' as StatusEnum,
        Declined: 'declined' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Canceled: 'canceled' as StatusEnum
    };
}


